import React, { useState } from 'react';
import KpiAdmin from './KpiAdmin';
import KpiCyclesAdmin from './KpiCyclesAdmin';
import ManagerKpi from './ManagerKpi';
import { useAuth } from '../context/AuthContext';

export default function KpiHub() {
  const { isSuperAdmin, isAdmin } = useAuth();
  const [tab, setTab] = useState(isSuperAdmin() ? 'admin' : 'assessment');

  const tabs = [
    ...(isSuperAdmin() ? [{ key: 'admin', label: 'Admin' }, { key: 'cycles', label: 'Cycles' }] : []),
    ...((isSuperAdmin() || isAdmin()) ? [{ key: 'assessment', label: 'Admin Assessment' }] : [])
  ];

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-4">KPI</h1>
      <div className="border-b mb-4">
        <nav className="-mb-px flex space-x-6" aria-label="Tabs">
          {tabs.map(t => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`${tab === t.key ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700'} whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm`}
            >{t.label}</button>
          ))}
        </nav>
      </div>

      {tab === 'admin' && isSuperAdmin() && <KpiAdmin />}
      {tab === 'cycles' && isSuperAdmin() && <KpiCyclesAdmin />}
      {tab === 'assessment' && (isSuperAdmin() || isAdmin()) && <ManagerKpi mode="admin" showHeader={false} />}
    </div>
  );
}



